import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { NewReposTable } from '../components/code/NewReposTable';
import { WatchedRepos } from '../components/code/WatchedRepos';
export function Code() {
  return <>
      <PageHeader title="What the world is building this week" lede="The hundred most-starred repositories created in the last seven days, straight from GitHub. It shows what developers are building right now, and how much of it is for agents." data-id="element-989" data-mp="ancruxn2fsgo" />
      <div className="mx-auto max-w-[1400px] px-5 pt-8 md:px-8" data-id="element-990" data-mp="189tn7xc8nvzs">
        <NewReposTable data-id="element-991" data-mp="1877ehudm3afz" />
        <WatchedRepos data-id="element-992" data-mp="tcsw9w1vg52d" />
      </div>
    </>;
}